import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-coupon-success-modal',
  templateUrl: './coupon-success-modal.page.html',
  styleUrls: ['./coupon-success-modal.page.scss'],
})
export class CouponSuccessModalPage implements OnInit {
  getPointData: any;
  couponData: any = null;
  resType: any;
  qrtype: any
  constructor(
    private modalController: ModalController
  ) { }

  ngOnInit() {
    console.log(this.couponData)
    this.getPointData = this.couponData;
    //console.log("couponData= ", this.getPointData);
  }

  closeModal(type) {
    this.modalController.dismiss(type);
  }

}
